<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_3221_17994)">
            <path d="M8.00006 5C7.44778 5 7.00006 5.44772 7.00006 6C7.00006 6.55228 7.44778 7 8.00006 7H16.0001C16.5523 7 17.0001 6.55228 17.0001 6C17.0001 5.44772 16.5523 5 16.0001 5H8.00006Z" fill="currentColor" />
            <path d="M8.00006 9C7.44778 9 7.00006 9.44771 7.00006 10C7.00006 10.5523 7.44778 11 8.00006 11H16.0001C16.5523 11 17.0001 10.5523 17.0001 10C17.0001 9.44771 16.5523 9 16.0001 9H8.00006Z" fill="currentColor" />
            <path d="M7.00006 14C7.00006 13.4477 7.44778 13 8.00006 13H12.0001C12.5523 13 13.0001 13.4477 13.0001 14C13.0001 14.5523 12.5523 15 12.0001 15H8.00006C7.44778 15 7.00006 14.5523 7.00006 14Z" fill="currentColor" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.00006 1C3.89549 1 3.00006 1.89543 3.00006 3V21C3.00006 22.1046 3.89549 23 5.00006 23H19.0001C20.1046 23 21.0001 22.1046 21.0001 21V3C21.0001 1.89543 20.1046 1 19.0001 1H5.00006ZM5.00006 3L19.0001 3V21H5.00006V3Z"
                fill="currentColor"
            />
            <path d="M2.00006 6C2.00006 5.44772 1.55235 5 1.00006 5C0.447776 5 6.10352e-05 5.44772 6.10352e-05 6V18C6.10352e-05 18.5523 0.447776 19 1.00006 19C1.55235 19 2.00006 18.5523 2.00006 18V6Z" fill="currentColor" />
            <path d="M23.0001 5C23.5523 5 24.0001 5.44772 24.0001 6V18C24.0001 18.5523 23.5523 19 23.0001 19C22.4478 19 22.0001 18.5523 22.0001 18V6C22.0001 5.44772 22.4478 5 23.0001 5Z" fill="currentColor" />
        </g>
    </svg>
</template>
